import type { PaperProps } from '@mui/material/Paper';
import Paper from '@mui/material/Paper';
import { forwardRef, memo } from 'react';

export const APP_PAPER_RADIUS = {
  xs: 4,
  md: 6,
} as const;

/**
 * アプリ共通の角丸Paperコンポーネント。
 * 入力画面などで一貫した角丸スタイルを適用するために使用します。
 */
const AppPaper = memo(
  forwardRef<HTMLDivElement, PaperProps>(function AppPaperInner({ sx, ...props }, ref) {
    const mergedSx = Array.isArray(sx)
      ? [{ borderRadius: APP_PAPER_RADIUS }, ...sx]
      : [{ borderRadius: APP_PAPER_RADIUS }, sx].filter(Boolean);

    return <Paper ref={ref} {...props} sx={mergedSx} />;
  })
);

export default AppPaper;
